import { Box, Stack, Typography } from '@mui/material';
import { SettingsSectionHeaderProps } from './settings-section-header.types';

/**
 * Group heading rendered above a SettingsSectionCard (outside its border):
 * title + optional description + optional right-aligned action. On mobile (xs)
 * the action drops under the text so it doesn't squeeze the description into a
 * narrow column.
 */
export const SettingsSectionHeader = ({
  title,
  description,
  action,
}: SettingsSectionHeaderProps) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    alignItems="flex-start"
    justifyContent="space-between"
    spacing={{ xs: 1.5, sm: 2 }}
  >
    <Box>
      <Typography variant="subtitle1" fontWeight={700} color="custom.OV.sys.onSurface">
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="custom.OV.sys.onSurfaceVariant" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      ) : null}
    </Box>
    {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
  </Stack>
);

SettingsSectionHeader.displayName = 'SettingsSectionHeader';
